import { createFileRoute, Outlet } from "@tanstack/react-router";

export const Route = createFileRoute("/conector-vip")({
  head: () => ({
    meta: [
      { title: "Conector VIP — Locales off-market — Bizaclia" },
      {
        name: "description",
        content:
          "Cuéntanos qué local buscas y te notificaremos cuando haya oportunidades off-market que encajen con tus requisitos.",
      },
      { property: "og:title", content: "Conector VIP — Locales off-market — Bizaclia" },
      {
        property: "og:description",
        content:
          "Indica tus preferencias y te avisaremos cuando haya locales off-market que encajen contigo.",
      },
      { name: "robots", content: "noindex, nofollow" },
    ],
  }),
  component: () => <Outlet />,
});
